<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogStatus"
      persistent
      origin="top center"
      content-class="warranty-dialog"
      :max-width="dialogWidth"
    >
      <v-card>
        <!-- HEADER -->
        <v-card-title
          class="headline dialog-custom-header white-background custom-border-bottom custom-header-blue-text"
        >
          Serial Numbers : {{ serialObject?.product }} ({{
            serialObject?.barcode
          }})
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="p-8 font-size-16">
          <perfect-scrollbar
            class="scroll p-3"
            :options="{ suppressScrollX: true }"
            style="max-height: 70vh; min-height: 50vh"
          >
            <v-form
              ref="serialFormRff"
              v-model.trim="serialFormRff"
              lazy-validation
              @submit.stop.prevent="onDetailSubmit()"
            >
              <!-- SUMMARY HEADER -->
              <v-row class="p-0 border-bottom">
                <v-col md="6" class="mb-n1 mt-n3">
                  <label class="font-weight-600 m-0 font-color-primary">
                    Total Available : {{ serialObject.initial_stock }}
                  </label>
                </v-col>

                <v-col md="6" class="text-right mb-n1 mt-n3">
                  <label class="font-weight-600 m-0 font-color-primary">
                    (<v-icon :color="iconColor">{{ iconName }}</v-icon
                    >) Adjusted Quantity : {{ activeCount }} /
                    {{ serialObject?.adjusted_quantity }}
                  </label>
                </v-col>
              </v-row>

              <!-- MAIN CONTENT -->
              <template v-if="serialList.length">
                <v-row>
                  <v-col lg="12" md="12">
                    <h3 class="font-weight-600 text--red">
                      <v-alert
                        text
                        prominent
                        dense
                        color="red darken-5"
                        class="mb-0 data_retention"
                        icon="mdi-alert"
                      >
                        Note: Please ensure that serial numbers are selected
                        according to the adjusted quantity.</v-alert
                      >
                    </h3>
                  </v-col>
                </v-row>

                <!-- TYPE 1 : SUBTRACTION -->
                <template v-if="isCalcType1">
                  <v-card
                    class="headline white-background custom-header-blue-text"
                  >
                    <v-card-title>
                      <v-row>
                        <v-col md="12">
                          <v-checkbox
                            @change="selectAllSerialNumbers"
                            hide-details
                            :true-value="1"
                            :false-value="0"
                            class="my-0 py-0 px-0 mx-0 dense-checkbox"
                            color="cyan"
                            label="Automatically Select Serial Numbers"
                          />
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-subtitle>
                      <v-row>
                        <v-col
                          v-for="(row, i) in serialList"
                          :key="i"
                          lg="2"
                          md="2"
                        >
                        
                          <div class="d-flex">
                            <v-chip-group multiple v-if="row?.activated == 1">
                              <v-chip
                                @click="selecteData(row)"
                                :class="{
                                  customChipChild: enities.includes(row.id),
                                }"
                                label
                              >
                                {{ row.text }}
                              </v-chip>
                            </v-chip-group>

                            <v-tooltip
                              v-else
                              top
                              content-class="custom-top-tooltip"
                              :key="`product-serial_numbers-${row?.id}-${i}-${row?.barcode_image}`"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  style="
                                    background: #e0e0e0 !important;
                                    margin: 4px 8px 4px 0 !important;
                                    opacity: 0.4;
                                  "
                                  outlined
                                  label
                                >
                                  {{ row.text }}
                                </v-chip>
                              </template>
                              <span> Unavailable </span>
                            </v-tooltip>

                            <div class="mt-3">
                              <showBarcode
                                :barcodeUrl="row.barcode_image"
                                title="Barcode"
                                :barcode-text="row.text"
                              />
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-subtitle>
                  </v-card>
                </template>

                <!-- TYPE 2 : ADDING -->
                <template v-else-if="isCalcType2">
                  <!-- AUTO YES/NO -->
                  <v-card
                    class="headline white-background custom-header-blue-text"
                  >
                    <v-card-text>
                      <v-row class="mt-5 mb-2">
                        <v-col md="8">
                          <label class="font-weight-700 font-size-16"
                            >Auto Generated?</label
                          >
                          <RadioInputCustom
                            v-model="isAutoGenerated"
                            row
                            color="red darken-4"
                            :items="[
                              {
                                label: 'Yes',
                                value: 1,
                              },
                              {
                                label: `No`,
                                value: 0,
                              },
                            ]"
                            @change="resetAddedList"
                          ></RadioInputCustom>
                        </v-col>

                        <!-- IMPORT -->
                        <v-col md="4" v-if="isManual">
                          <label class="font-weight-700 font-size-16"
                            >Upload your file:</label
                          >
                          <div>
                            <v-btn
                              outlined
                              color="cyan"
                              class="custom-bold-button text-white mt-3 pt-0"
                              @click="importDialog = true"
                            >
                              Import
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>

                      <!-- PREFIX + NUMBER -->
                      <v-row class="d-flex justify-content-center mt-5 mb-2">
                        <v-col md="4">
                          <label class="font-weight-700 font-size-16"
                            >Prefix</label
                          >
                          <v-text-field
                            dense
                            filled
                            solo
                            flat
                            color="cyan"
                            placeholder="Prefix"
                            v-model.trim="serial_prefix"
                          />
                        </v-col>

                        <v-col md="4">
                          <label class="font-weight-700 font-size-16"
                            >No.</label
                          >
                          <v-text-field
                            type="number"
                            dense
                            filled
                            solo
                            flat
                            color="cyan"
                            placeholder="Prefix no."
                            v-model.trim="serial_prefix_no"
                            @keypress="isNumber"
                          />
                        </v-col>

                        <!-- PREVIEW + GENERATE -->
                        <v-col md="4">
                          <label class="font-weight-700 font-size-16"
                            >Preview</label
                          >
                          <div class="d-flex align-center">
                            <span
                              class="font-weight-700 font-size-16 text-uppercase"
                            >
                              {{ serial_prefix }}-{{ serial_prefix_no }}
                            </span>
                            <v-btn
                              depressed
                              color="cyan"
                              class="custom-bold-button text-white ml-4"
                              :disabled="!serial_prefix_no"
                              @click="generatePrefixes"
                              >Generate</v-btn
                            >
                          </div>
                        </v-col>
                      </v-row>

                      <!-- LIST OF GENERATED/IMPORTED -->
                      <v-row v-if="added_searial_numbers.length" class="mb-6">
                        <v-col
                          v-for="(row, i) in added_searial_numbers"
                          :key="i"
                          lg="3"
                          md="3"
                        >
                          <div class="d-flex">
                            <input
                              v-model="row.text"
                              :placeholder="'Enter barcode ' + (i + 1)"
                              class="w-100 input-style"
                            />
                            <v-icon left color="red" @click="deleteNumber(i)">
                              mdi-close
                            </v-icon>
                          </div>

                          <div v-if="row.error" class="red--text">
                            Serial Number Already Exists
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </template>

              <!-- NO LIST FOUND -->
              <template v-else>
                <v-row class="d-flex justify-content-center mt-2 mb-2">
                  <p class="m-0 row-not-found font-weight-500 font-size-16">
                    <img
                      height="30"
                      width="35"
                      :src="$assetURL('media/error/empty.png')"
                    />
                    Uhh... There are no serial number at the moment.
                  </p>
                </v-row>
              </template>
            </v-form>
          </perfect-scrollbar>

          <v-divider />

          <v-card-actions>
            <v-spacer></v-spacer>

            <div class="warrant-manage-action">
              <v-btn
                color="cyan"
                depressed
                class="mx-2 custom-bold-button white--text"
                @click="onDetailSubmit"
              >
                Save
              </v-btn>

              <v-btn
                depressed
                class="mx-2 custom-grey-border custom-bold-button"
                :disabled="serialLoading"
                @click="$emit('close:dialog')"
              >
                Close
              </v-btn>
            </div>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- IMPORT DIALOG -->
    <ImportTemplate
      :dialog="importDialog"
      title="Import Serial Number"
      sample-url="/import-samples/productbarcode.xlsx"
      api-url="serial-number/import"
      @close="importDialog = false"
      @response="getData"
    />
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import showBarcode from "@/view/components/showBarcode.vue";
import ImportTemplate from "@/view/pages/partials/Import-Template.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { v4 as uuidv4 } from "uuid";
import { cloneDeep } from "lodash";
import RadioInputCustom from "@/view/components/RadioInputCustom.vue";
import { mapGetters } from "vuex";

export default {
  name: "create-or-update-warranty",
  mixins: [CommonMixin],

  props: {
    serialArray: {
      type: Array,
      default() {
        return [];
      },
    },
    serialObject: {
      type: Object,
      default() {
        return {};
      },
    },
    dialogStatus: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      importDialog: false,
      serialList: [],
      serialFormRff: true,
      serialLoading: false,

      enities: [],
      serial_prefix: null,
      serial_prefix_no: null,
      added_searial_numbers: [],
      isAutoGenerated: 1,
    };
  },

  watch: {
    serialArray: {
      immediate: true,
      deep: true,
      handler(val) {
        this.serialList = JSON.parse(JSON.stringify(val || []));
      },
    },

    dialogStatus: {
      immediate: true,
      handler(isOpen) {
        if (!isOpen) return;

        if (this.isCalcType1) {
          this.enities = Array.isArray(this.serialObject.adjust_serial_array)
            ? [...this.serialObject.adjust_serial_array]
            : [];
        }

        if (this.isCalcType2) {
          this.added_searial_numbers = Array.isArray(
            this.serialObject.adjust_serial_array
          )
            ? [...this.serialObject.adjust_serial_array]
            : [];
        }

        /* const {
          adjust_serial_array = [],
          calculation_type,
          adjusted_quantity,
        } = this.serialObject;

        this.enities = [
          ...(Array.isArray(adjust_serial_array) ? adjust_serial_array : []),
        ];

        if (calculation_type?.id === 1) {
          this.autoFillSubtraction(adjusted_quantity);
        }

        if (calculation_type?.id === 2) {
          this.loadAdditionData();
        }

        this.sortArray(); */
      },
    },
  },

  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },

    isCalcType1() {
      return this.serialObject?.calculation_type?.id === 1;
    },

    isCalcType2() {
      return this.serialObject?.calculation_type?.id === 2;
    },

    activeCount() {
      return this.isCalcType1
        ? this.enities.length
        : this.added_searial_numbers.length;
    },

    iconColor() {
      return this.isCalcType1 ? "red" : "green";
    },

    iconName() {
      return this.isCalcType1 ? "mdi-minus" : "mdi-plus";
    },

    isManual() {
      return this.isAutoGenerated == 0;
    },
    ...mapGetters([""]),
  },

  methods: {
    selectAllSerialNumbers(value) {
      if (value == 1) {
        const {
          adjust_serial_array = [],
          calculation_type,
          adjusted_quantity,
        } = this.serialObject;

        this.enities = [
          ...(Array.isArray(adjust_serial_array) ? adjust_serial_array : []),
        ];

        if (calculation_type?.id === 1) {
          this.autoFillSubtraction(adjusted_quantity);
        }

        if (calculation_type?.id === 2) {
          this.loadAdditionData();
        }

        this.sortArray();
      } else {
        this.enities = [];
      }
    },
    getData(data) {
      this.added_searial_numbers = this.lodash.cloneDeep(data);
    },

    resetAddedList() {
      this.added_searial_numbers = [];
    },

    resetManualFields() {
      this.added_searial_numbers = [];
      this.serial_prefix = null;
      this.serial_prefix_no = null;
    },

    autoFillSubtraction(adjustedQty) {
      if (!adjustedQty || this.enities.length >= adjustedQty) return;

      const needed = adjustedQty - this.enities.length;

      const autoSelect = this.serialList
        .filter((s) => s.activated == 1) 
        .filter((s) => !this.enities.includes(s.id))
        .slice(0, needed)
        .map((s) => s.id);

      this.enities.push(...autoSelect);
    },

    loadAdditionData() {
      this.serial_prefix = this.serialObject?.serial_prefix ?? null;
      this.serial_prefix_no = this.serialObject?.serial_prefix_no ?? null;

      this.added_searial_numbers = Array.isArray(
        this.serialObject?.adjust_serial_array
      )
        ? [...this.serialObject.adjust_serial_array]
        : [];
    },

    sortArray() {
      const orderMap = new Map(this.enities.map((id, idx) => [id, idx]));

      const ordered = this.serialList.filter((item) => orderMap.has(item.id));
      const unordered = this.serialList.filter(
        (item) => !orderMap.has(item.id)
      );

      ordered.sort((a, b) => orderMap.get(a.id) - orderMap.get(b.id));

      this.serialList = [...ordered, ...unordered];
    },

    selecteData(row) {
      if (!row) return;

      const idx = this.enities.indexOf(row.id);

      idx !== -1 ? this.enities.splice(idx, 1) : this.enities.push(row.id);

      this.sortArray();
    },

    generatePrefixes() {
      const adjusted = this.serialObject?.adjusted_quantity;

      if (!this.serial_prefix_no || adjusted <= 0) return;

      this.added_searial_numbers = [];

      for (let i = 1; i <= adjusted; i++) {
        const prefix = this.serial_prefix ? `${this.serial_prefix}-` : "";
        const num = String(Number(this.serial_prefix_no) + i - 1).padStart(
          this.serial_prefix_no.length,
          "0"
        );

        this.added_searial_numbers.push({
          uuid: uuidv4(),
          text: `${prefix}${num}`,
          editable: true,
          error: false,
        });
      }
    },

    deleteNumber(i) {
      this.added_searial_numbers.splice(i, 1);
    },

    onDetailSubmit() {
      const adjustedQty = Number(this.serialObject.adjusted_quantity);
      const calcType = this.serialObject?.calculation_type?.id;

      const activeList =
        calcType === 1 ? this.enities : this.added_searial_numbers;

      if (activeList.length !== adjustedQty) {
        return ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            "Ensure that the adjusted quantity entered matches the Serial Number count"
          )
        );
      }

      this.$emit("save", cloneDeep(activeList));
    },

    isNumber(e) {
      if (e.key < "0" || e.key > "9") e.preventDefault();
    },
  },

  components: { showBarcode, ImportTemplate, RadioInputCustom },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid lightgray;
}
.font-color-primary {
  font-size: 18px;
  color: #24326d !important;
}
.input-style {
  padding: 4px !important;
  border: 1px solid darkgrey;
}
</style>
